// import { TOURIST_FORMS } from "@/pages/user/forms/config/tourist";
// import { BUSINESS_FORMS } from "@/pages/user/forms/config/business";

// export const resolveFormConfig = (category, purposeCode) => {
//   if (!category || !purposeCode) return null;

//   if (category === "Tourist") {
//     return TOURIST_FORMS[purposeCode] || null;
//   }

//   if (category === "Business") {
//     return BUSINESS_FORMS[purposeCode] || null;
//   }

//   return null;
// };



import { TOURIST_FORMS } from "@/pages/user/forms/config/tourist";
import { BUSINESS_FORMS } from "@/pages/user/forms/config/business";
import { SHARED_SECTIONS } from "@/pages/user/forms/config/formBaseConfig";
import { api } from "@/utils/api";

export const resolveFormConfig = async (category, purposeCode, applicationId = null) => {
  if (!category || !purposeCode) return null;

  let baseConfig = null;

  if (category === "Tourist") {
    baseConfig = TOURIST_FORMS[purposeCode] || null;
  } else if (category === "Business") {
    baseConfig = BUSINESS_FORMS[purposeCode] || null;
  }

  if (!baseConfig) return null;

  // ✅ Clone the base config to avoid mutating the original
  const config = {
    ...baseConfig,
    sections: [...baseConfig.sections],
  };

  // ✅ If viewing an existing application, check for additional info requests
 if (applicationId) {
  try {
    const hasAdditionalInfo = await checkAdditionalInfoRequests(applicationId);
    
    if (hasAdditionalInfo) {
      console.log("✅ Additional info requests found, adding section");
      
      // Find the declaration section index
      const declarationIndex = config.sections.findIndex(
        (s) => s.id === "declaration"
      );
      
      if (declarationIndex !== -1) {
        // ✅ Insert AFTER declaration (declarationIndex + 1)
        config.sections.splice(
          declarationIndex + 1,
          0,
          SHARED_SECTIONS.Additional_Information_Requested
        );
      } else {
        // Or append at the end if no declaration section
        config.sections.push(SHARED_SECTIONS.Additional_Information_Requested);
      }
    } else {
      console.log("ℹ️ No additional info requests found");
    }
  } catch (error) {
    console.error("Error checking additional info requests:", error);
  }
}

  return config;
};

// ✅ Helper function to check if there are additional info requests
const checkAdditionalInfoRequests = async (applicationId) => {
  try {
 
    const res = await api.userGetAdditionalInfoRounds(applicationId);
    const rounds = Array.isArray(res.data?.rounds) ? res.data.rounds : [];

    return rounds.length > 0;
  } catch (error) {
    console.error("Error fetching additional info rounds:", error);
    return false;
  }
};